import { render, staticRenderFns } from "./SwitchButton.vue?vue&type=template&id=38dcfd0f&scoped=true&"
import script from "./SwitchButton.vue?vue&type=script&lang=js&"
export * from "./SwitchButton.vue?vue&type=script&lang=js&"
import style0 from "./SwitchButton.vue?vue&type=style&index=0&id=38dcfd0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dcfd0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38dcfd0f')) {
      api.createRecord('38dcfd0f', component.options)
    } else {
      api.reload('38dcfd0f', component.options)
    }
    module.hot.accept("./SwitchButton.vue?vue&type=template&id=38dcfd0f&scoped=true&", function () {
      api.rerender('38dcfd0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/lib/components/ui/SwitchButton.vue"
export default component.exports